// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"download-progress_wrapper_H0-","progressWrapper":"download-progress_progressWrapper_3O9"};